export default __webpack_public_path__ + "static/media/IMG_0885.ba6e5a37.ba6e5a37.JPG";